export const getters = {
  mileageItemsrows: state => state.mileage_items,
  Mileages: state => state.mileages,
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/mileages/getters.js